/* global stripe */
require('babel-polyfill');
const axios = require('axios');
const fb = window.firebaseUtils;
const { successMessage, failureMessage, showLoader, hideLoader } = require('./utils');
const fetch = require('isomorphic-fetch');
//
// Create a Stripe client.
const stripe = Stripe(process.env.STRIPE_CLIENT_API_KEY);

//const db = require('../../functions/lib/firebaseUtils');
//const calculatePaymentDetailsForEnquiryId = require('../../functions/lib/calculatePaymentDetailsForEnquiryId');
//const sendEnquiryEmailUsingTemplate = require('../../functions/services/sendEnquiryEmailUsingTemplate');
let card = null;
let enquiry = null;
let modal = $('#paymentPopup');

$(_ => {
  card = initialiseStripeCard('#stripe-card');

  $('body').on('click', '.paymentPopup__stripeButton', _ => {
    $('.paymentPopup__bankTransferSection').hide();
    $('.paymentPopup__TTAPaymentSection').hide();
    $('.paymentPopup__stripePaymentSection').show();
  });
  $('body').on('click', '.paymentPopup__bankTransferButton', _ => {
    $('.paymentPopup__stripePaymentSection').hide();
    $('.paymentPopup__TTAPaymentSection').hide();
    $('.paymentPopup__bankTransferSection').show();
  });
  $('body').on('click', '.paymentPopup__TTAButton', _ => {
    $('.paymentPopup__stripePaymentSection').hide();
    $('.paymentPopup__bankTransferSection').hide();
    $('.paymentPopup__TTAPaymentSection').show();
    payByTTA();
  });
  $('body').on('click', '#finalise-payment-button', _ => submitPayment());
});

function looksLikePostcode(str) {
  // From: https://stackoverflow.com/a/51885364/757237
  return str.match(/([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})/);
}

window.payByTTA = payByTTA;
function payByTTA(enq) {
  enquiry = enq;

  showLoader();

  // Get the enquiry data
  let enquiryId = localStorage.getItem('currentEnquiryId');
  fb.callFunction('invoiceSummary', 'POST', { enquiryId })
    .then(response => {
  //fb.getFromCollection('enquiry', enquiryId)
  //  .then(response => {
      enquiry = response
      let invoiceId = enquiry.invoiceShortId;
      console.log('enquiry', enquiry);

      // Get payment details
      const payDtls = enquiry.paymentDetails || {};
      console.log('payDtls: ', payDtls);
      const depositVal = payDtls.deposit || 0;
      const outstandingVal = payDtls.outstanding || 0;

      let amountToPay = 0;

      // If we wish to make it a single payment instead of deposit, we can change it here (and the related code in functions)
      if (enquiry.invoiceStatus === 'DEPOSIT_DUE') {
        amountToPay = depositVal;
      } else {
        amountToPay = outstandingVal;
      }

      // /only for testing purpose, remove for live
      // amountToPay = 50; 
      if (!amountToPay) {
        successMessage('Nothing to pay', 'There is nothing left to pay for this invoice');
        hideLoader();
        return;
      }

      // Get address line 1 and postcode
      const address = (enquiry && ((enquiry.client && enquiry.client.address) || enquiry.address)) || '';
      const addressLine1 = address.split('\n')[0]
      // Find a line in the address which contains 3 numbers and 3/4 letters (i.e. looks like a postcode)
      const postCode = address.split('\n').reverse().find(looksLikePostcode);

      // Format date for TTA (It should already be in the correct format, but just in case)
      function formatDateForFelloh(date) {
        // Convert input to date if it's a string
        if (typeof date === 'string') {
          date = new Date(date);
        };
        // Convert to ISO string and split at T to get YYYY-MM-DD
        return date.toISOString().split('T')[0];
      };

      // Create a payment request to Felloh/TTA
      fb.callFunction('createPaymentRequest', 'POST', {
        /*amount: amountToPay,
        invoiceShortId: enquiry.invoiceShortId,
        enquiryId: enquiryId,
        customerName: `${enquiry.client.forename} ${enquiry.client.surname}`,
        customerEmail: enquiry.client.email,
        addressLine1: addressLine1,
        postCode: postCode,
        paymentDescription: `Enquiry ${enquiryId} - ${enquiry.activityDescription} in ${enquiry.destinationName} departing ${enquiry.departureDate}`*/
        customer_name: `${enquiry.client.forename} ${enquiry.client.surname}`,
        email: enquiry.client.email,
        booking_reference: invoiceId,
        departure_date: formatDateForFelloh(enquiry.departureDate),
        return_date: null,
        gross_amount: Math.round(Number(outstandingVal)*100),
        amount_to_pay: Math.round(Number(amountToPay)*100),
        felloh_booking_id: enquiry.fellohBookingId?enquiry.fellohBookingId:false,
      })
      .then(response => {
          console.log(response)
          if (!(response.message.paymentRedirectUrl == "" || response.message.paymentRedirectUrl == undefined)) {
            window.location.href = response.message.paymentRedirectUrl;
            console.log('redirect to: ', response.message.paymentRedirectUrl);
          };
        })
        .catch(err => {
          console.error(err);
          failureMessage('Update failed', err.message || err.responseMessage || 'Unknown error. Please try again.');
        })
        .then(_ => {
          console.log('after');
          hideLoader();
        });
    });
};

window.displayPaymentPopup = displayPaymentPopup;
function displayPaymentPopup(enq) {
  enquiry = enq;
  console.log('enquiry: ', enquiry);

  $('#invoiceId').text(enquiry.shortInvoiceId);
  const address = (enquiry && ((enquiry.client && enquiry.client.address) || enquiry.address)) || '';
  // Find a line in the address which contains 3 numbers and 3/4 letters (i.e. looks like a postcode)
  const postcode = address
    .split('\n')
    .reverse()
    .find(looksLikePostcode);

  $('.paymentPopup__stripePaymentSection').hide();
  $('.paymentPopup__bankTransferSection').hide();
  $('.paymentPopup__TTAPaymentSection').hide();
  modal.find('input').val('');
  modal.find('#postcode').val(postcode || '');

  const payDtls = enquiry.paymentDetails || {};
  console.log('payDtls: ', payDtls);
  const depositVal = payDtls.deposit || 0;
  const outstandingVal = payDtls.outstanding || 0;

  let amountToPay = 0;

  if (enquiry.invoiceStatus === 'DEPOSIT_DUE') {
    amountToPay = depositVal;
  } else {
    amountToPay = outstandingVal;
  }
  
  //only for testing purpose, remove for live
 // amountToPay = 50; 
  if (!amountToPay) {
    successMessage('Nothing to pay', 'There is nothing left to pay for this invoice');
    return;
  }
  modal.find('#stripeAmount').val(amountToPay.toFixed(2));

  modal.modal('show');
}

function initialiseStripeCard(containerId) {
  // Create an instance of Elements.
  const elements = stripe.elements();

  // Custom Styling can be passed to options when creating an Element.
  const style = {
    base: {
      color: '#32325d',
      lineHeight: '18px',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': { color: '#aab7c4' },
    },
    invalid: { color: '#fa755a', iconColor: '#fa755a' },
  };
  // Create an instance of the card Element.
  //   const card = elements.create('card', { hidePostalCode: true, style });
  const card = elements.create('card', { hidePostalCode: true, style });

  // Add an instance of the card Element into the `card-element` <div>.
  card.mount(containerId);

  // Handle real-time validation errors on the card Element.
  card.addEventListener('change', event => {
    document.getElementById('card-errors').textContent = event.error ? event.error.message : '';
  });
  return card;
}

async function submitPayment() {
  //const elements = stripe.elements();
  // prettier-ignore
  const amount = parseFloat($('#paymentPopup').find('#stripeAmount').val());
  // prettier-ignore
  const postcode = $('#paymentPopup').find('#postcode').val().trim();

  if (!amount) {
    return alert('Amount to pay is invalid');
  }
  if (!postcode) {
    return alert('Postcode must be provided');
  }

  showLoader();

  const addressDetails = { address_zip: postcode, currency: 'eur' }; // NOTE: I don't think currency is actually used here
  console.log(addressDetails);
 
  /////////// NEW PaymentIntentAPI
    //get enquiry and client details
  const enquiryId =  localStorage.getItem('currentEnquiryId')
  //const enquiry = await db.getRecord('enquiry', enquiryId);
  //const client = await db.getRecord('client', enquiry.clientId);
  const data = {
    enquiryId: localStorage.getItem('currentEnquiryId'),
    amount: amount,
    postcode: postcode,
    card:'card',
    invoiceShortId: enquiry.invoiceShortId
  };


   
  // get client details for billigDetails
  
  
  const billingDetails = {
    email : enquiry.client.email,
    name : `${enquiry.client.forename} ${enquiry.client.surname}`
  }
  const { FIREBASE_FUNCTIONS_BASE_URL } = process.env;
  // 1.	Check if full payment has been made. If so, show message of No Payment Required
  const checkFullPayment = await axios.post(FIREBASE_FUNCTIONS_BASE_URL + '/submitClientPayment',{
    mode:'checkFullPayment',
    enquiryId: enquiryId,
  }); 
  //console.log(checkFullPayment); 
  if(checkFullPayment.status === 400 )
  {
    hideLoader();
    return failureMessage(checkFullPayment.data);
  }

  //2.If point #1 is true, create stripe paymentIntent on server,
  // and send cleintSecret back to client
 
  const {data:client_secret} = await axios.post(FIREBASE_FUNCTIONS_BASE_URL + '/submitClientPayment',{
    amount : parseInt(amount * 100),
    invoiceShortId: enquiry.invoiceShortId,
    mode:'getSecretClient',
    enquiryId: enquiryId,
  }).then( function(response) {
    //console.log(response);
    return response;
  }).catch(function (error){
    hideLoader();
    return failureMessage('Something goes wrong! Please try again!');
  });

  //3.If point # 2 is successful, create payment Method,
  const paymentMethodReq =  await stripe.createPaymentMethod({
    type : 'card',
    card : card,
    billing_details : billingDetails
  });
//4.	In case of point #3 success, 
// make stripe payment using confirmCardPayment method else show error message to client

  if(typeof paymentMethodReq.paymentMethod.id === 'undefined')
  {
    hideLoader();
    return failureMessage('Somthing goes wrong with Stripe Payment Method. Please try again!');
  }

  const paymentConfirmCardPayment =  await stripe.confirmCardPayment(client_secret,{
    payment_method: paymentMethodReq.paymentMethod.id,
 });

 //5.	In case paymentIntent success, re-calculate payment outstanding etc
 if (paymentConfirmCardPayment.paymentIntent && paymentConfirmCardPayment.paymentIntent.status === 'succeeded')
 {

    const webhook = await axios.post(FIREBASE_FUNCTIONS_BASE_URL + '/submitClientPayment',{
      amount : amount ,
      enquiryId: enquiryId,
      card:card,
      mode:'webhook'
    }).then(function (response){
      successMessage('Thanks!', false);
      if (window.loadInvoiceSummary) window.loadInvoiceSummary(enquiry.id); // Reload invoice details
      $('#paymentPopup').modal('hide');
    }).catch(function(error){
      hideLoader();
      //console.log(err);
      return failureMessage('Payment has been made But Database is not updated successfully. Please ask Zuba-Ski for this message!');
    });

 }
 else{ 
  hideLoader();
  return failureMessage('Your payment has not been completed.');
 }
//console.log(paymentConfirmCardPayment)  ;
return;

}
